import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./rules-editor-device-config-section-open.module.scss";
import { RulesEditorDeactivatableSection } from "./rules-editor-deactivatable-section";
import VelavuInput from "../../../elements/velavu-input";
import { classArr } from "../../../helper/style-helper";

export interface RulesEditorDeviceConfigSectionOpenProps {
	className?: string;
	config: string;
	onChangeConfig: (config: string) => void;
	error?: boolean;
	onClose: () => void;
	disabled?: boolean;
	disabledTooltip?: string;
}

export default function RulesEditorDeviceConfigSectionOpen(
	props: RulesEditorDeviceConfigSectionOpenProps,
) {
	const { t } = useTranslation();

	return (
		<RulesEditorDeactivatableSection
			className={props.className}
			title={t("rules.editor.device_config.title")}
			onDeactivate={props.disabled ? undefined : props.onClose}
			deactivateDisabled={props.disabled}
			deactivateTooltip={props.disabledTooltip}
		>
			<VelavuInput
				className={styles.input}
				value={props.config}
				onChange={props.onChangeConfig}
				placeholder={`{\n  "heartbeat_rate_s": 1800\n}`}
				inputClassName={classArr("id16", styles.inputField)}
				fullWidth
				multiline
				rows={3}
				error={props.error}
				autoResize
				spellCheck={false}
				disabled={props.disabled}
			/>
		</RulesEditorDeactivatableSection>
	);
}
